import createSagaMiddleware from 'redux-saga';
import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import reducerFactory, { bootReducers } from './reducerFactory';
import getReducerRegistryMiddleware from './reducerSagaRegistryMiddleware';
import ReducerSagaRegistry from './ReducerSagaRegistry';
import noopReducer from './noopReducer';

let sagaMiddleware = {};

export const preserveStoreState = (reducers, initialState = {}) => {
    const reducerKeys = Object.keys(reducers);
    Object.keys(initialState)
        .filter((item) => reducerKeys.indexOf(item) === -1)
        .forEach((item) => {
            // eslint-disable-next-line no-param-reassign
            reducers[item] = noopReducer;
        });
    return combineReducers(reducers);
};

const storeFactory = (reducers, initialState, rootSaga, externalMiddlewares) => {
    const reducerSagaRegistry = new ReducerSagaRegistry();
    sagaMiddleware = createSagaMiddleware();
    let middlewares = [sagaMiddleware, getReducerRegistryMiddleware(reducerSagaRegistry)];
    if (externalMiddlewares) {
        middlewares = [...middlewares, ...externalMiddlewares];
    }
    // Redux Devtools for debugging during development.
    const composeEnhancers = process.env.NODE_ENV === 'development' && (!__SERVER__) && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? // eslint-disable-line
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ // eslint-disable-line
                  // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
              })
            : compose;

    const store = createStore(
        preserveStoreState(reducerFactory(reducers), initialState),
        initialState,
        composeEnhancers(applyMiddleware(...middlewares))
    );

    store.initialReducers = reducers;
    store.tasks = rootSaga ? [sagaMiddleware.run(rootSaga)] : [];

    reducerSagaRegistry.initReducers(
        {
            ...bootReducers,
            ...store.initialReducers,
        },
        (asyncReducers) => store.replaceReducer(preserveStoreState(asyncReducers, store.getState()))
    );

    reducerSagaRegistry.initSagas(
        rootSaga.injectedSagas,
        (asyncSaga) => {
            let task = null;
            if (asyncSaga) {
                task = sagaMiddleware.run(asyncSaga);
                store.tasks.push(task);
            }
            return task;
        },
        (sagaTask) => sagaTask && sagaTask.cancel()
    );

    return store;
};

export const getSagaMiddleWare = () => sagaMiddleware;

export default storeFactory;
